import { last, take } from 'lodash'
import { LOCIZE_NAMESPACE } from 'main/common'
import { i18nKeyPrefix } from 'main/pages/Search/i18n'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { FilterControl } from '../common'
import IFullSearchProps from '../types'
import FilterForm from './FilterForm'

const PRE = `${i18nKeyPrefix}-FILTERS-DAYS-PER-WEEK`

export default function DaysPerWeekFilter(props: IFullSearchProps) {
  const {
    filters,
    displayForm,
    palette,
    onChangeFilters,
    onRequestCloseForm,
    onRequestDisplayForm,
  } = props

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const isActive = !!filters.daysPerWeek.length
  const daysPerWeek = filters.daysPerWeek.sort()
  function label() {
    if (isActive) {
      if (daysPerWeek.length > 2) {
        return t(`${PRE}-TWO`, {
          first: take(daysPerWeek, daysPerWeek.length - 1).join(', '),
          second: last(daysPerWeek),
        })
      } else if (daysPerWeek.length === 2) {
        return t(`${PRE}-TWO`, { first: daysPerWeek[0], second: daysPerWeek[1] })
      }
      return `${daysPerWeek[0]} ${daysPerWeek[0] > 1 ? t(`${PRE}-PLURAL`) : t(`${PRE}-SINGULAR`)}`
    }
    return t(`${PRE}-DEFAULT`)
  }

  return (
    <div data-pendo="daysPerWeekFilterButton">
      <FilterControl
        isActive={isActive}
        label={label()}
        displayForm={displayForm}
        palette={palette}
        onRequestCloseForm={onRequestCloseForm}
        onRequestDisplayForm={onRequestDisplayForm}
        filterForm={
          <FilterForm
            filters={filters}
            onChangeFilters={onChangeFilters}
            onRequestCloseForm={onRequestCloseForm}
          />
        }
      />
    </div>
  )
}
